// G-C5: literales en euskera (default) y castellano.
export type Lang = 'eu' | 'es'

const DICT = {
  // Issue #74: la sección «Panel» se llama ahora «ALERTA» (con icono rojo, ver `Icon name="alerta"`).
  panel: { eu: 'ALERTA', es: 'ALERTA' },
  seleccionaTemporada: { eu: 'Aukeratu denboraldia', es: 'Selecciona una temporada' },
  cerrada: { eu: 'itxita', es: 'cerrada' },
  eskola: { eu: 'UKE Eskola', es: 'UKE Eskola' },
  f7: { eu: 'F7', es: 'F7' },
  f11: { eu: 'F11', es: 'F11' },
  alDia: { eu: 'Eguneratuta', es: 'Al día' },
  pendiente: { eu: 'Falta betetzeko', es: 'Pendiente' },
  asistencia: { eu: 'Asistentzia', es: 'Asistencia' },
  minutaje: { eu: 'Minutajea', es: 'Minutaje' },
  ultimaActualizacion: { eu: 'Azken eguneraketa', es: 'Última actualización' },
  sinDatos: { eu: 'Daturik ez', es: 'Sin datos' },
  sinEquipos: { eu: 'Ez dago talderik', es: 'No hay equipos' },
  todoAlDia: { eu: 'Dena eguneratuta', es: 'Todo al día' },
  // Feedback de navegación, 2026-10-02: el diálogo de pendientes no decía ni el equipo ni qué era.
  detallePendientesTitulo: { eu: 'Falta duena', es: 'Pendientes' },
  sesionesPendientes: { eu: 'Asistentzia falta duten saioak', es: 'Sesiones con asistencia pendiente' },
  jornadasPendientes: { eu: 'Minutaje falta duten jardunaldiak', es: 'Jornadas con minutaje pendiente' },
  cerrar: { eu: 'Itxi', es: 'Cerrar' },
  // Ventana de pendientes (look & feel, 2026-10-22)
  sesion: { eu: 'saio', es: 'sesión' },
  sesionesN: { eu: 'saio', es: 'sesiones' },
  jornadaN: { eu: 'jardunaldi', es: 'jornada' },
  jornadasN: { eu: 'jardunaldi', es: 'jornadas' },
  hoy: { eu: 'gaur', es: 'hoy' },
  ayer: { eu: 'atzo', es: 'ayer' },
  haceDias: { eu: 'duela {n} egun', es: 'hace {n} días' },
  entrenamiento: { eu: 'Entrenamendua', es: 'Entrenamiento' },
  partido: { eu: 'Partida', es: 'Partido' },
  irAlEquipo: { eu: 'Taldera joan', es: 'Ir al equipo' },
  // Issue #78 (club, 2026-10-22): recordatorio manual de asistencia pendiente.
  enviarRecordatorio: { eu: '✉ Oroigarria bidali', es: '✉ Enviar recordatorio' },
  confirmarRecordatorio: { eu: '{equipo} taldeko entrenatzaileei asistentziaren oroigarria bidali?', es: '¿Enviar a los entrenadores de {equipo} un recordatorio de la asistencia pendiente?' },
  recordatorioEnviado: { eu: 'Oroigarria bidalita: {nombres}', es: 'Recordatorio enviado a: {nombres}' },
  recordatorioSinPendientes: { eu: 'Ez dago asistentziarik falta', es: 'No hay asistencia pendiente' },
  recordatorioSinEntrenadores: { eu: 'Talde honek ez du entrenatzailerik esleituta', es: 'Este equipo no tiene entrenadores asignados a quien enviarlo' },
  errorGenerico: { eu: 'Errore bat gertatu da', es: 'Ha ocurrido un error' },
  vistaEquipos: { eu: 'Taldeen egoera', es: 'Estado equipos' },
  vistaEntrenadores: { eu: 'Entrenatzaileak', es: 'Entrenadores' },
  // Issue #77 (club, 2026-10-22): pestaña de jugadores en alerta de minutaje.
  vistaJugadores: { eu: 'JOKALARIAK', es: 'JUGADORES' },
  eligeEquipoJugadores: { eu: 'Aukeratu talde bat alerta-jokalariak ikusteko', es: 'Elige un equipo para ver sus jugadores en alerta' },
  sinJugadoresAlerta: { eu: 'Ez dago alerta-jokalaririk', es: 'Ningún jugador en alerta' },
  sinEquiposMinutaje: { eu: 'Ez dago F7 edo F11 talderik', es: 'No hay equipos de F7 ni F11' },
  sinEquiposEntrenadores: { eu: 'Ez dago talderik denboraldi honetan', es: 'No hay equipos en esta temporada' },
  // Issue #85 (club, 2026-10-23): ALERTA › Ausencias y Tarjetas.
  vistaAusencias: { eu: 'Absentziak', es: 'Ausencias' },
  vistaTarjetas: { eu: 'Txartelak', es: 'Tarjetas' },
  ausenciasAyuda: {
    eu: 'Astebete baino gehiago entrenatzera etorri gabe dauden jokalariak (zerrenda pasatu den saioak bakarrik).',
    es: 'Jugadores que llevan más de una semana sin asistir (solo cuentan las sesiones en las que se pasó lista).',
  },
  sinAusencias: { eu: 'Ez dago absentziarik', es: 'Ningún jugador con ausencias' },
  jugador: { eu: 'Jokalaria', es: 'Jugador' },
  equipo: { eu: 'Taldea', es: 'Equipo' },
  motivo: { eu: 'Arrazoia', es: 'Motivo' },
  sinEntrenar: { eu: 'Entrenatu gabe', es: 'Sin entrenar' },
  diasN: { eu: '{n} egun', es: '{n} días' },
  ultimaAsistencia: { eu: 'Azkena: {fecha}', es: 'Última: {fecha}' },
  nuncaEnBloque: { eu: 'Ez da etorri bloke honetan', es: 'No ha venido en este bloque' },
  faltasSeguidas: { eu: '{n} huts jarraian', es: '{n} faltas seguidas' },
  motivoSinMarcar: { eu: 'Markatu gabe', es: 'Sin marcar' },
  motivoAusente: { eu: 'Ez da etorri', es: 'No asiste' },
  tarjetasAyuda: {
    eu: 'F11: 5 txartel horiz zigorra. Ohartarazita = zikloan 4 ditu; zigortuta = azken jardunaldian itxi du zikloa.',
    es: 'F11: sanción cada 5 amarillas. Apercibido = lleva 4 en el ciclo; sancionado = cerró el ciclo en la última jornada.',
  },
  sinTarjetas: { eu: 'Ez dago ohartarazitako edo zigortutako jokalaririk', es: 'Ningún jugador apercibido ni sancionado' },
  sinEquiposF11: { eu: 'Ez dago F11 talderik', es: 'No hay equipos de F11' },
  sancionados: { eu: 'Zigortuak', es: 'Sancionados' },
  apercibidos: { eu: 'Ohartarazitakoak', es: 'Apercibidos' },
  situacion: { eu: 'Egoera', es: 'Situación' },
  sancionado: { eu: 'Zigortua', es: 'Sancionado' },
  apercibido: { eu: 'Ohartarazita', es: 'Apercibido' },
  cumpleEn: { eu: 'J{n}-n betetzen du', es: 'Cumple en J{n}' },
  amarillasCiclo: { eu: '{n}/5 horia', es: '{n}/5 amarillas' },
  amarillas: { eu: 'Horiak', es: 'Amarillas' },
  rojas: { eu: 'Gorriak', es: 'Rojas' },
} as const

export type DictKey = keyof typeof DICT


export function t(key: DictKey, lang: Lang): string {
  return DICT[key][lang]
}

// Issue #42, 2026-10-02: "Eskola" -> "UKE Eskola" y F7/F11 en mayúscula en toda la app.
// `equipo.categoria` llega en minúsculas desde el enum de Prisma; valores no reconocidos se
// devuelven sin tocar.
export function categoriaLabel(categoria: string, lang: Lang): string {
  if (categoria === 'eskola' || categoria === 'f7' || categoria === 'f11') return DICT[categoria][lang]
  return categoria
}
